module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OmRaKS/images/cover.jpg?1730635551040",
      "alt": "This image is the cover for the book Big Book of Words You Should Know"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Big Book of Words You Should Know\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Do you know what \"quatrefoil\" and \"impolitic\" mean? What about \"halcyon\" or \"narcolepsy\"?"), _c('br'), _c('br'), _vm._v("This book is a handy, easy-to-read reference guide to the proper parlance for any situation.")]), _vm._v(" In this book you will find: Words You Absolutely Should Know (covert, exonerate, perimeter); Words You Should Know But Probably Don't (dour, incendiary, scintilla); Words Most People Don't Know (schlimazel, thaumaturgy, epergne); Words You Should Know to Sound Overeducated (ad infinitum, nugatory, garrulity); Words You Probably Shouldn't Know (priapic, damnatory, labia majora); and more."), _c('br'), _c('br'), _vm._v("Whether writing an essay, studying for a test, or trying to impress friends, family, and fellow cocktail party guests with their prolixity, you will achieve magniloquence, ebullience, and flights of rhetorical brilliance.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Olsen, Michelle Bevilacqua, Justin Cord Hayes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0